import { displayToast, sendAppsignalError } from "../modules/utils";

export default class InfiniteScroll {
  constructor(node) {
    this.element = node;
    this.observerElement = this.element.querySelector(".js-infinite-scroll-observer");

    this.url = new URL(this.element.dataset.infiniteScrollUrl, window.location.origin);
    this.offsetParam = this.element.dataset.offsetParam;
    this.offset = 1;

    this.initialize();
  }

  initialize() {
    this.url.searchParams.set(this.offsetParam, this.offset);

    this.observer = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting) {
        this.fetchContent();
      }
    });

    this.observer.observe(this.observerElement);
  }

  fetchContent() {
    this.element.classList.add("is-loading");

    fetch(this.url, {
      retries: 3,
      retryDelay: 1000,
    })
      .then((response) => {
        this.response = response;

        if (response.status === 200) {
          return response.json();
        }

        throw new Error("Fetching infinite scroll failed");
      })
      .then((data) => {
        const { html } = data;

        if (!html) {
          this.observer.unobserve(this.observerElement);
          return;
        }

        this.observerElement.insertAdjacentHTML("beforebegin", data.html);

        this.url.searchParams.set(this.offsetParam, (this.offset += 1));
      })
      .catch((e) => {
        console.error(e);
        displayToast(this.element.dataset.errorMessage);
        sendAppsignalError(e, "InfiniteScroll", {
          response: this.response,
        });
      })
      .finally(() => {
        this.element.classList.remove("is-loading");
      });
  }
}
